module.exports = __webpack_public_path__ + "static/media/traffic-light-go.b4127457.svg";